import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Auth = ({ children }) => {
    const { credentials } = useSelector(state => state.credentialsSlice);
    const navigate = useNavigate();
    useEffect(() => {
        if (!credentials?.token) {
            navigate("/");
        }
    }, [credentials]);
    return (
        <>
            {children}
        </>
    )
}

export default Auth